<template>
	<div @click="$emit('change')" class="checkbox">
		<span v-if="checked" class="check" />
	</div>
</template>

<style scoped>
.checkbox {
	height: 14px;
	width: 14px;
	display: inline-flex;
	border: 1px solid rgba(0, 0, 0, 0.5);
	box-shadow: inset 0px 0px 10px -1px rgba(0, 0, 0, 0.3);
	position: relative;
	background: #dedede;
	border-radius: 2px;
	cursor: pointer;
	vertical-align: middle;
}

.check {
	border-left: 3px solid #424242;
	border-bottom: 3px solid #424242;
	display: inline-block;
	height: 6px;
	width: 12px;
	transform: rotate(-45deg) translate(-1px, 2px);
}
</style>

<script>
export default {
	name: 'checkbox',
	props: ['checked'],
}
</script>
